// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2efgf","title":"Header_title__rGdjB","side":"Header_side__1oPSp"};